import {
  DataTableDataSearchDto,
  DatatableDataUserGroupSelectionDto,
  DataTableFooterSearchDto,
  FooterDataDtoResponse,
} from '@asset-metrix/portal-gateway-client-js';
import { QueryFunction } from '@tanstack/react-query';

import { extractErrorMessage } from '../../utils/errorMessage';
import {
  QueryKeyWithRole,
  unwrapQueryKeyWithRole,
} from '../../utils/prependRoleId';
import { HttpError } from '../errors';
import { portalGatewayClient } from '../portalGatewayClient';

export type FetchFooterDataQueryKey = readonly [
  widgetId: string,
  pageFilterSelections: DataTableDataSearchDto['selection'],
  tableFilterSelections: DataTableDataSearchDto['selection'],
  aggregationTypes: DataTableFooterSearchDto['aggregationTypes'],
  userGroupSelection?: DatatableDataUserGroupSelectionDto['userGroupSelection'],
  stakeAdjusted?: DataTableDataSearchDto['stakeAdjusted'],
  groupByColumnId?: string,
  ...string[],
];
export const fetchFooterData: QueryFunction<
  FooterDataDtoResponse,
  QueryKeyWithRole<FetchFooterDataQueryKey>
> = async ({ queryKey }) => {
  const [
    widgetId,
    pageFilterSelections,
    tableFilterSelections,
    aggregationTypes,
    userGroupSelection,
    stakeAdjusted,
    groupByColumnId,
  ] = unwrapQueryKeyWithRole(queryKey).params;

  const response = await portalGatewayClient.table.getFooterData(widgetId, {
    selection: { ...pageFilterSelections, ...tableFilterSelections },
    aggregationTypes,
    userGroupSelection,
    stakeAdjusted,
    ...(groupByColumnId != null && { groupByColumnId }),
  });

  if (!response.ok) {
    throw new HttpError(
      extractErrorMessage(response.error) || 'Error fetching footer data',
      response
    );
  }

  return response.data;
};
